import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-touch-readmore',
  templateUrl: './touch-readmore.component.html',
  styleUrls: ['./touch-readmore.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class TouchReadmoreComponent implements OnInit {
  @Input() text = '';

  more = false;
  intro = '';
  full = '';
  separator = 'read less';

  constructor() {
  }

  ngOnInit(): void {
    if(this.text !== '' && this.text !== undefined){
      if (this.text.includes(this.separator)) {
        const text = this.text.split(this.separator);
        this.intro = text[0];
        this.full = text[1].replace('" data-read-more="read more">read more','');
      } else {
        this.intro = this.text;
      }
    }
  }

  /**
   * Toggle read more
   */
  readMore(): void {
    this.more = !this.more;
  }

}
